import { Placeholder } from './Placeholder';

export const WelcomeMessage = () => <Placeholder className="min-h-[100px]">Welcome Message</Placeholder>;
